/**
 * TanStack Query hooks for `custom-favicon-upload`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	customFaviconUploadQueryKeys,
	type CreateCustomFaviconUploadBody,
	type ListCustomFaviconUploadResponse,
	type CustomFaviconUploadRow,
} from "./api";

export function useCustomFaviconUploadList(): UseQueryResult<ListCustomFaviconUploadResponse, Error> {
	return useQuery({
		queryKey: customFaviconUploadQueryKeys.list(),
		queryFn: list,
	});
}

export function useCustomFaviconUploadCreate(): UseMutationResult<CustomFaviconUploadRow, Error, CreateCustomFaviconUploadBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customFaviconUploadQueryKeys.all });
		},
	});
}

export function useCustomFaviconUploadDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customFaviconUploadQueryKeys.all });
		},
	});
}
